<div class="p-10">
  <h2 class="text-3xl text-primary pb-12">Kleiderverwaltung</h2>
  <div class="container mx-auto p-4">
    <app-clothing-list></app-clothing-list>
  </div>
</div>
